import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Guides from "@/components/Guides";
import CtaBand from "@/components/CtaBand";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <div id="top" className="min-h-screen bg-white font-sans text-navy antialiased">
        <Header />
        <main>
          <Hero />
          <Guides />
          <CtaBand />
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </div>
    </ErrorBoundary>
  );
}

export default App;
